<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Help</h4>
</div>
<div class="modal-body pb-0" *ngIf="!success">
  <app-dynamic-form [fields]="fields" [form]="form"></app-dynamic-form>
  <div class="my-2 text-danger" *ngIf="error">{{ error }}</div>
  <div class="d-flex justify-content-end pb-3">
    <button
      class="btn btn-success me-2"
      (click)="submitFeedback()"
      [disabled]="form.invalid"
    >
      Submit
    </button>
    <button class="btn btn-danger" (click)="dismissModal()">Cancel</button>
  </div>
</div>
<div class="modal-body pb-0" *ngIf="success">
  <div class="mb-3 text-success">Your question has been submitted.  We will review and respond via email.</div>
  <div class="d-flex justify-content-end pb-3">
    <button class="btn btn-danger" (click)="dismissModal()">Close</button>
  </div>
</div>
